export class AwsSourceAccountAttributes {
    'roleArn';
    'organizationId';
    'metricsConfigRegion';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "metricsConfigRegion",
            "baseName": "metricsConfigRegion",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
